import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import AttendeeComponent from '../components/AttendeeComponent';
import i18n from '../utils/i18n';
import ApiClient from '../utils/apiClient';
import { openModal } from '../actions/modalsActions';
import { modals } from '../utils/constants';
import { copyListWithNewObject } from '../utils/other';

class AttendeesListContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      attendeesList: [],
      showPresenceInfo: false,
      errors: false
    };

    this.getAttendeesList = this.getAttendeesList.bind(this);
    this.openEmergencyContactModal = this.openEmergencyContactModal.bind(this);
    this.toggleAttendeePresent = this.toggleAttendeePresent.bind(this);
  }

  componentDidMount() {
    this.getAttendeesList(this.props.accessToken);
  }

  getAttendeesList(accessToken) {
    ApiClient.get(`/api/v1/attendees-list/${accessToken}`)
      .then(response => {
        this.setState({
          attendeesList: response.data.attendees.map(user => ({
            ...user,
            disabled: false
          })),
          showPresenceInfo: response.data.show_mark_attendance_button
        });
      })
      .catch(() => {
        this.setState({
          errors: true
        });
      });
  }

  toggleAttendeePresent(bookingId, value) {
    let attendeeToUpdate = this.state.attendeesList.find(
      attendee => attendee.booking_id === bookingId
    );
    attendeeToUpdate = {
      ...attendeeToUpdate,
      disabled: true,
      present: value
    };

    this.setState({
      attendeesList: copyListWithNewObject(
        this.state.attendeesList,
        attendeeToUpdate,
        attendee => attendee.booking_id === bookingId
      )
    });

    ApiClient.put(`/api/v1/attendees-list/${this.props.accessToken}`, {
      booking_id: bookingId,
      present: attendeeToUpdate.present
    })
      .then(() => {
        this.setState({
          attendeesList: copyListWithNewObject(
            this.state.attendeesList,
            { ...attendeeToUpdate, disabled: false },
            attendee => attendee.booking_id === bookingId
          )
        });
      })
      .catch(() => {
        this.setState({
          errors: true
        });
      });
  }

  openEmergencyContactModal = userId => {
    this.props.openModal(modals.EMERGENCY_CONTACT, {
      userId,
      accessToken: this.props.accessToken
    });
  };

  render() {
    const { errors, attendeesList, showPresenceInfo } = this.state;
    return (
      <div className="col-md-12">
        <h2 className="header2">{i18n.t('attendeesList.PAGE_TITLE')}</h2>
        {!errors && (
          <table className="table table-bordered border-light">
            <thead>
              <tr>
                <th>{i18n.t('attendeesList.FULL_NAME')}</th>
                <th>{i18n.t('attendeesList.BOOKING_DATE')}</th>
                {showPresenceInfo && (
                  <th>{i18n.t('attendeesList.PRESENCE')}</th>
                )}
                <th style={ { width: '200px' } } />
              </tr>
            </thead>
            <tbody>
              {attendeesList.map(attendee => (
                <AttendeeComponent
                  key={ attendee.booking_id }
                  openEmergencyContactModal={ this.openEmergencyContactModal }
                  toggleAttendeePresent={ this.toggleAttendeePresent }
                  disabled={ attendee.disabled }
                  userId={ attendee.user_id }
                  firstName={ attendee.first_name }
                  lastName={ attendee.last_name }
                  present={ attendee.present }
                  bookingId={ attendee.booking_id }
                  datetime={ attendee.datetime }
                  showPresenceInfo={ showPresenceInfo }
                />
              ))}
            </tbody>
          </table>
        )}
        {errors && (
          <span className="text-danger">
            {i18n.t('attendeesList.GETTING_ERROR')}
          </span>
        )}
      </div>
    );
  }
}

AttendeesListContainer.propTypes = {
  accessToken: PropTypes.string.isRequired,
  openModal: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
  openModal: (modal, modalData) => dispatch(openModal(modal, modalData)),
  dispatch
});

export default connect(null, mapDispatchToProps)(AttendeesListContainer);



// WEBPACK FOOTER //
// ./src/containers/AttendeesListContainer.js